export default "__VITE_ASSET__C5Z6nHid__"